import React, { useEffect, useState } from 'react';

import 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react'; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme

import AgGridService from '../../../shared/services/ag-grid/ag-grid.service';
import ReportListService from '../reporting-and-analytics/report-list/report-list.service';
import ReportListToolbarComponent from '../reporting-and-analytics/report-list/components/report-list-toolbar/report-list-toolbar.component';

import IException from '../../../shared/contracts/IException';
import useLoader from '../../../shared/components/loading-dialog/useLoader.hook';
import LoadingDialogComponent from '../../../shared/components/loading-dialog/loading-dialog.component';
import { GridReadyEvent } from 'ag-grid-community';
import ISourceMap from '../../../shared/contracts/ISourceMap';
import useReportCoreApi from './useReportCoreApi';
import GrossToNetService from './gross-to-net.service';
import GrossToNetToolbarComponent from './components/gross-to-net-toolbar.component';
import CreateSourceMapDialogComponent from './create-sourcemap-dialog/create-sourcemap-dialog.component';
import useAppStoreContext from '../../../shared/context/app-store/app-store.context';


interface IProps {

}
function GrossToNetPage({ }: IProps) {

  // ---
  const { getGrossToNetList } = useReportCoreApi();
  const { sourceList, setSourceList } = useAppStoreContext();
  const [showCreateSourceMapDialog, setShowCreateSourceMapDialog] = useState<boolean>(false);
  const [isReloadData, setIsReloadData] = useState<boolean>(false);
  const { getDefaultColDef, getDefaultProps } = new AgGridService();

  const sourceListLoader = useLoader({
    loaderName: 'Source List',
    loadAsync: () => getGrossToNetList({
      doIf: () => sourceListLoader.isNotLoading,
      doBefore: () => {
        sourceListLoader.SET_LOADING('Fetching...');
        setSourceList([]);
      },
      onFulfilled: (data) => {
        setSourceList(data);
        sourceListLoader.SET_SUCCESS('Fetch Success.!');
      },
      onException: (exception: IException) => {
        sourceListLoader.SET_FAILURE(exception.title + ' - ' + exception.message);
      }
    })
  });

  useEffect(() => {
    sourceListLoader.loadAsync();
  }, [isReloadData]);


  const handleGridReady = (e: GridReadyEvent<ISourceMap>) => {
    e.api.autoSizeAllColumns();
  }

  return (<>

    {/* Loading dialog */}
    <LoadingDialogComponent loaderHook={sourceListLoader} />

    {/* Toolbar */}
    <GrossToNetToolbarComponent onReload={sourceListLoader.loadAsync} handleCreateSourceMapClick={() => { setShowCreateSourceMapDialog(true) }} />

    {/* Create Report dialog */}
    {showCreateSourceMapDialog && <CreateSourceMapDialogComponent open={showCreateSourceMapDialog}
      onClose={() => { setShowCreateSourceMapDialog(false) }}
      onApply={() => {
        setShowCreateSourceMapDialog(false);
        setIsReloadData(true);
      }} />}

    {/* The AG Grid component */}
    <div className={'ag-theme-quartz'} style={{ height: `calc(100vh - ${108}px)` }} >

      <AgGridReact {...getDefaultProps({})}
        onGridReady={handleGridReady}
        defaultColDef={{ ...getDefaultColDef() }}
        columnDefs={GrossToNetService.colDefs}
        rowData={sourceList || []}
      />

    </div>

  </>);
}
export default GrossToNetPage;